import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";
import Panel from "Components/Panel/Panel";
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const AnalyticsCharts = ({
  sectorSelected,
  managerSelected,
  employeeSelected,
  selectedActualDate
}) => {
  const [assignmentStatics, setAssignmentStatics] = useState(null);
  const [sectorChart, setSectorChart] = useState(null);
  const [functionsChart, setFunctionsChart] = useState(null);
  const [dateTimeChart, setDateTimeChart] = useState(null);
  const [totalHoursChart, setTotalHoursChart] = useState(0);

  function getCategoriesBasicBarChart(data) {
    return {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: data.categories
      }
    }
  }

  function getDataBasicBarChart(data) {
    return [
      {
        name: "Acionamentos por Sector",
        data: data.values
      }
    ]
  }

  useEffect(() => {
    const fetchData = async () => {
      if (sectorSelected || managerSelected || employeeSelected || selectedActualDate) {
        const parameters = {
          sectorId: sectorSelected,
          managerId: managerSelected,
          employeeId: employeeSelected,
          dtAssignment: selectedActualDate
        };

        try {
          const assignmentData = await ExecuteAxios.api('get', `/assignment/assignment-filter-statistics/`, { params: parameters });
          setAssignmentStatics([assignmentData]);
        } catch (error) {
          console.error("Error fetching assignment statistics:", error);
        }
      }
    };

    fetchData();
  }, [sectorSelected, managerSelected, employeeSelected, selectedActualDate]);

  useEffect(() => {
    if (assignmentStatics && assignmentStatics.length > 0) {
      assignmentStatics.forEach(element => {
        if (element) {
          setSectorChart(transformData(element.sectorName));
          setFunctionsChart(transformData(element.functionName));
          setDateTimeChart(transformData(element.dtAssignment));
          setTotalHoursChart(element.totalHours);
        } else {
          setSectorChart('');
          setFunctionsChart('');
          setDateTimeChart('');
          setTotalHoursChart(0);
        }
      });
    }
  }, [assignmentStatics]);

  function transformData(data) {
    if (!data) {
      return null;
    }

    const categories = [];
    const values = [];

    data.forEach(item => {
      categories.push(item[Object.keys(item)[0]]);
      values.push(item[Object.keys(item)[1]]);
    });

    return { categories, values: values };
  }


  var totalCost = totalHoursChart * 160;
  var formattedTotalCost = totalCost.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <div className="app" style={{ padding: '2%', display: 'flex', flexDirection: 'column', width: '100%', height: '100%', justifyContent: 'align-content' }}>
      <LoadingIndicator loaded={(sectorChart || sectorChart==='') &&
        (functionsChart || functionsChart==='') &&
        (dateTimeChart || dateTimeChart==='')}>
        <Panel>
          <span>Informação X: {totalHoursChart} | Informação Y: {formattedTotalCost}</span>
        </Panel>
        {!sectorChart || sectorSelected ? null :
          <Chart
            options={getCategoriesBasicBarChart(sectorChart)}
            series={getDataBasicBarChart(sectorChart)}
            type="bar"
            width="100%"
            height="70%"
          />
        }

        {!functionsChart || !sectorSelected ? null :
          <Chart
            options={getCategoriesBasicBarChart(functionsChart)}
            series={getDataBasicBarChart(functionsChart)}
            type="bar"
            width="100%"
            height="47.5%"
          />
        }

        {!dateTimeChart || !sectorSelected ? null :
          <Chart
            options={getCategoriesBasicBarChart(dateTimeChart)}
            series={getDataBasicBarChart(dateTimeChart)}
            type="bar"
            width="100%"
            height="47.5%"
          />
        }
      </LoadingIndicator>
    </div>
  );
};

export default AnalyticsCharts;
